import { ThemeContext } from 'styled-components';
import { useContext } from 'react';

const useTheme = () => useContext(ThemeContext);

export { useTheme };
